import { render } from "./ModalAccounts.vue?vue&type=template&id=2b7e4c92"
import script from "./ModalAccounts.vue?vue&type=script&lang=js"
export * from "./ModalAccounts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__